import { useCallback } from 'react';

import * as pas from '@interlayer/js/hooks/auth/pas';
import { useContinueLoginWithSessionToken } from '@interlayer/js/hooks/auth/hooks/useContinueLoginWithSessionToken';
import { useIsSlotUpgrade } from '@interlayer/js/app/components/main/Registration/components/templates/SlotReg/hooks/useIsSlotUpgrade';
import { useIsRetailUpgrade } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/hooks/useIsRetailUpgrade';
import { useContinueSlotLightLogin } from '@interlayer/js/app/components/main/Registration/components/templates/SlotReg/components/slotUpgrade/steps/LoginStep/hooks/useContinueSlotLightLogin';
import { useContinueRetailLightLogin } from '@interlayer/js/app/components/main/Registration/components/templates/RetailReg/components/retailUpgrade/steps/LoginStep/hooks/useContinueRetailLightLogin';

export const useContinueLogin = () => {
    const isSlotUpgrade = useIsSlotUpgrade();
    const isRetailUpgrade = useIsRetailUpgrade();
    const continueLoginWithSessionToken = useContinueLoginWithSessionToken();
    const continueSlotLightLogin = useContinueSlotLightLogin();
    const continueRetailLightLogin = useContinueRetailLightLogin();

    return useCallback(async ({ credentials, afterRegisterLogin, isAfterLoginWithCredentials }) => {
        const { data: { sessionToken: { sessionToken } } } = await pas.getTempToken();

        if (isRetailUpgrade) {
            return continueRetailLightLogin({ userName: credentials.userName, sessionToken });
        }

        if (isSlotUpgrade) {
            return continueSlotLightLogin({ userName: credentials.userName, sessionToken });
        }

        await continueLoginWithSessionToken({ ...credentials, sessionToken, afterRegisterLogin, isAfterLoginWithCredentials });
    }, [continueLoginWithSessionToken, continueRetailLightLogin, continueSlotLightLogin, isRetailUpgrade, isSlotUpgrade]);
};
